import { takeEvery, select, call, put } from 'redux-saga/effects';
import { examination } from '../api/examination';
import { EXAMINATION_SAGA } from '../actions/examination';
import { safe } from './util';
import {
  updateExaminationResultAction,
} from '../actions/result';
import { push } from 'connected-react-router';

function* postExamination() {
  const result = yield select(state => state.result);
  const question = yield select(state => state.question);
  const answers = [];
  const answerMap = 'ABCDEFGHIJKLMN';
  Object.values(question).map(v => answers.push({
    id: String(v.id),
    answer: v.chosen.map(c => answerMap[c]),
  }));
  const examinationResult = yield call(examination, {
    face_result_id: result.face.id,
    tongue_result_id: result.tongue.id,
    answers
  });
  // alert(JSON.stringify(examinationResult));

  yield put(updateExaminationResultAction(examinationResult));
  yield put(push('/report'));
}

export function* watchExamination() {
  yield takeEvery(EXAMINATION_SAGA, safe(postExamination));
}



// WEBPACK FOOTER //
// ./src/sagas/examination.js